var map = {
	"./act-0.mp3": 368,
	"./act-00.mp3": 369,
	"./act-1.mp3": 370,
	"./act-2.mp3": 371,
	"./act-3.mp3": 372,
	"./act-4.mp3": 373,
	"./act-5.mp3": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;